module.exports = __webpack_public_path__ + "img/section5-item3.61cde899.svg";